<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="editTransaction" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="Amount" prop="amount">
            <el-input v-model="form.amount" type="number" placeholder="Amount" :disabled="!isAdmin">
              <template slot="prepend"><i class="fa fa-dollar-sign"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item label="Office" prop="officeId">
            <el-select v-model="form.officeId" value-key="id" :disabled="!isAdmin">
              <el-option v-for="item in formattedUserOffices" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Void?" prop="retirementAmt">
            <el-switch v-model="form.void" :active-value="true" :inactive-value="false"
              :disabled="!isAdmin"></el-switch>
          </el-form-item>
          <el-form-item label="Date">
            {{ form.date }}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Close</el-button>
        <el-button type="primary" @click="updateTransaction" v-if="isAdmin">Update Transaction</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import map from 'lodash/map';
import api from '@/api';
import { Required } from '@/util/formValidators';
import Transaction from '@/model/Transaction';
import OfficeToRefType from '@/util/OfficeToRefType';

export default {
  props: {
    transaction: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      form: new Transaction(),
      rules: {
        amount: [Required],
        officeId: [Required],
      },
    };
  },
  methods: {
    async updateTransaction() {
      this.errorMessage = null;
      try {
        await this.$refs.editTransaction.validate();
      } catch (e) {
        console.warn('Form is invalid', e);
        return;
      }

      this.isLoading = true;
      try {
        const response = await api.transaction.update(this.form);
        this.$notify.success({
          title: 'Success',
          message: 'Transaction saved.',
          position: 'bottom-right',
        });
        this.$emit('transactionUpdated', response.data);
        this.closeDialog();
      } catch (e) {
        this.errorMessage = get(e, 'response.data', 'An error occurred.');
      } finally {
        this.isLoading = false;
      }
    },
    closeDialog() {
      this.clearForm();
      this.$emit('close');
    },
    setFormFromTransaction(transaction) {
      if (transaction) {
        this.form = new Transaction(this.transaction);
      } else {
        this.clearForm();
      }
    },
    clearForm() {
      this.form = new Transaction(this.transaction);
      this.$refs.editTransaction.resetFields();
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
      'allUserOffices',
    ]),
    formattedUserOffices() {
      return map(this.allUserOffices, office => OfficeToRefType(office));
    },
  },
  watch: {
    transaction(val) {
      this.setFormFromTransaction(val);
    },
  },
  mounted() {
    if (this.transaction) {
      this.setFormFromTransaction(this.transaction);
    }
  },
};

</script>
